module.exports = __webpack_public_path__ + "assets/img/g2.a730b0c1.jpg";